import React, { useState } from 'react';
import { Paper, Typography, TextField, Button, Grid, Select, MenuItem, FormControl, InputLabel } from '@mui/material';

const initialSettings = {
  environment: 'production',
  apiEndpoint: 'https://api.aitalker.com',
  maxConcurrentUsers: 1000,
  loggingLevel: 'info',
};

const EnvironmentSettings = () => {
  const [settings, setSettings] = useState(initialSettings);

  const handleChange = (event) => {
    setSettings({
      ...settings,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Here you would typically send the settings to your backend
    console.log('Saving environment settings:', settings);
  };

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>Environment Settings</Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel id="environment-label">Environment</InputLabel>
              <Select
                labelId="environment-label"
                name="environment"
                value={settings.environment}
                onChange={handleChange}
              >
                <MenuItem value="production">Production</MenuItem>
                <MenuItem value="staging">Staging</MenuItem>
                <MenuItem value="development">Development</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              name="apiEndpoint"
              label="API Endpoint"
              value={settings.apiEndpoint}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              name="maxConcurrentUsers"
              label="Max Concurrent Users"
              type="number"
              value={settings.maxConcurrentUsers}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel id="logging-level-label">Logging Level</InputLabel>
              <Select
                labelId="logging-level-label"
                name="loggingLevel"
                value={settings.loggingLevel}
                onChange={handleChange}
              >
                <MenuItem value="debug">Debug</MenuItem>
                <MenuItem value="info">Info</MenuItem>
                <MenuItem value="warn">Warn</MenuItem>
                <MenuItem value="error">Error</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary">
              Save Settings
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default EnvironmentSettings;
